import { useEffect, useRef} from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

//api
import { ProjectManagementService } from '../../../service/projectmanagement-service';

//components
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import DeleteProject from '../DeleteProject'



const UpdateProject = ({ projectId, project }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate()
  const toast = useRef(null);

 

  //ripopola il form
  useEffect(() => {
    if (project) {
      setValue('name', project.name);
      setValue('notes', project.notes);
    }
  }, [project, setValue]);



  //chiamata PUT
  const onSubmit = (data) => {
    console.log(projectId);
    const payload = {
      ...data,
      id: projectId,
      name: data.name,
      notes: data.notes,
    };
    ProjectManagementService.updateExistingProject(
      projectId,
      payload,
      (response) => {
        toast.current.show({
          severity: 'success',
          summary: 'Modifica',
          detail: 'Progetto modificato!',
        });
        navigate('/dashboard/projects')
      }
    );
  };

  return (
    <div style={{ width: '50%' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="projectManagement__FormContainer">
          <div className="projectManagement__TextField">
            <label>Nome Azienda</label>
            <InputText
              id="projectName"
              {...register('name', {
                required: "Il nome dell'azienda è obbligatorio",
              })}
              className={errors.name ? 'p-invalid' : ''}
            />
            {errors.name && (
              <small className="p-error">{errors.name.message}</small>
            )}
          </div>
          <div className="projectManagement__TextField">
            <label>Descrizione</label>
            <InputTextarea
              id="projectManagement_Input"
              {...register('notes')}
              rows={5}
              cols={20}
            />
          </div>
          <div className="projectManagement__SaveBtn">
            <div>
              <Toast ref={toast} />
            <Button>Salva</Button>
            </div>
            <div>
              <DeleteProject/>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateProject;
